import { Grid } from '@material-ui/core';
import logoHubtec from '../../img/logo-hubtec.svg'
import React from 'react'

export const Footer = () => {
    return (
        <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
        >
            <p style={ { fontSize:'12.5px', fontWeight: '300' } }>Desarrollado por: </p>
            <img src={ logoHubtec } alt="Logo hubtec" title="Logo Hubtec"
                style={ { 'width':'95px','height':'95px', marginLeft: '10px' } }
            />
        </Grid>
    )
}
